export default __webpack_public_path__ + "static/media/msg.ff3ed838.svg";